import 'bootstrap/dist/css/bootstrap.css';
import './styles/globals.scss';
import { AuthProvider } from './services/auth/authProvider';
import { AuthManager } from './services/auth/AuthManager';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';

function App({ Component, pageProps}: any) {
  return (
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <AuthManager Component={Component} {...pageProps} />
        </AuthProvider>
      </I18nextProvider>
  );
}

export default App;
